import Player from '@vimeo/player';
import React, { useEffect, useRef } from 'react';

export type Props = {
  videoId: number;
  autoplay?: boolean;
  disabled?: boolean;
};

export const Vimeo: React.FC<Props> = ({
  autoplay = false,
  disabled = false,
  videoId,
}) => {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const playerRef = useRef<Player | null>(null);

  useEffect(() => {
    if (rootRef.current === null) return;

    playerRef.current ||= new Player(rootRef.current, {
      id: videoId,
      title: false,
      byline: false,
      portrait: false,
      responsive: true,
      autoplay,
    });

    if (disabled) {
      playerRef.current?.pause();
    }
  }, [autoplay, videoId, disabled]);

  // `responsive` sizes its wrapper from the video's own ratio via inline
  // padding; fill the parent instead so non-16:9 videos don't overflow it.
  return (
    <div
      ref={rootRef}
      className="vimeo-container h-full [&>div]:!h-full [&>div]:!p-0"
    />
  );
};
